import { useCallback, useState } from "react";

export const useCalendarNavigation = (initialMonth) => {
  const [currentMonth, setCurrentMonth] = useState(initialMonth || new Date());

  const goToPreviousYear = useCallback(() => {
    const newMonth = new Date(currentMonth);
    newMonth.setFullYear(currentMonth.getFullYear() - 1);
    setCurrentMonth(newMonth);
  }, [currentMonth]);

  const goToNextYear = useCallback(() => {
    const newMonth = new Date(currentMonth);
    newMonth.setFullYear(currentMonth.getFullYear() + 1);
    setCurrentMonth(newMonth);
  }, [currentMonth]);

  const goToPreviousMonth = useCallback(() => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(currentMonth.getMonth() - 1);
    setCurrentMonth(newMonth);
  }, [currentMonth]);

  const goToNextMonth = useCallback(() => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(currentMonth.getMonth() + 1);
    setCurrentMonth(newMonth);
  }, [currentMonth]);

  const handleMonthChange = useCallback((month) => {
    setCurrentMonth(month);
  }, []);

  return {
    currentMonth,
    setCurrentMonth,
    goToPreviousYear,
    goToNextYear,
    goToPreviousMonth,
    goToNextMonth,
    handleMonthChange,
  };
};
